<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const appStore = useAppStore()
const router = useRouter()

onMounted(() => {
  appStore.fetchEnvironment()
})

const envPillClass = computed(() => {
  return appStore.environment === 'ma-prod'
    ? 'bg-red-100 text-red-800'
    : 'bg-blue-100 text-blue-800'
})

async function handleSignOut() {
  await authStore.signOut()
  router.push('/login')
}
</script>

<template>
  <nav class="bg-white shadow-sm border-b">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center h-16">
        <div class="flex items-center space-x-8">
          <div class="flex items-center gap-2">
            <router-link to="/configs" class="text-xl font-semibold text-gray-900">
              Scalpel Config
            </router-link>
            <span
              class="px-2 py-0.5 text-xs font-medium rounded-full uppercase whitespace-nowrap"
              :class="envPillClass"
            >
              {{ appStore.environment }}
            </span>
          </div>

          <div class="hidden md:flex space-x-4">
            <router-link
              to="/configs"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              active-class="text-gray-900 bg-gray-100"
            >
              Configs
            </router-link>

            <router-link
              to="/api-keys"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              active-class="text-gray-900 bg-gray-100"
            >
              API Keys
            </router-link>

            <router-link
              to="/workstations"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              active-class="text-gray-900 bg-gray-100"
            >
              Workstations
            </router-link>

            <router-link
              to="/mms"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              active-class="text-gray-900 bg-gray-100"
            >
              MMS
            </router-link>

            <router-link
              to="/how-to"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              active-class="text-gray-900 bg-gray-100"
            >
              How To
            </router-link>

          </div>
        </div>

        <div class="flex items-center space-x-4">
          <span class="text-sm text-gray-600">
            {{ authStore.user?.email }}
          </span>
          <span
            class="px-2 py-1 text-xs font-medium rounded-full"
            :class="authStore.isAdmin ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'"
          >
            {{ authStore.role }}
          </span>
          <button
            @click="handleSignOut"
            class="px-3 py-2 text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>
